import { Grid } from '@chakra-ui/react';
import { Color } from 'src/theme/color';

export const TwoColumn = ({ children }: any) => {
	return (
		<Grid
			templateColumns="4fr 4fr"
			border={`1px solid ${Color.FROM_BORDER}`}
			borderRight="none"
			borderLeft="none"
		>
			{children}
		</Grid>
	);
};
